export default "__VITE_ASSET__CGliUN7I__"